
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import TooltipText from './TooltipText';

interface Treatment {
  name: string;
  member?: string;
  visitor?: string;
  single?: string;
  package?: string;
  price?: string;
  benefits?: string;
  tooltip?: string;
}

interface TreatmentTableProps {
  headers: string[];
  treatments: Treatment[];
  showTooltips?: boolean;
}

const TreatmentTable = ({ headers, treatments, showTooltips = false }: TreatmentTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          {headers.map((header, index) => (
            <TableHead 
              key={index} 
              className="text-juv-deep-chestnut font-semibold"
            >
              {header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {treatments.map((treatment, index) => (
          <TableRow key={index} className="hover:bg-juv-soft-blush/30">
            <TableCell className="font-medium text-juv-deep-chestnut">
              {showTooltips && treatment.tooltip ? (
                <TooltipText text={treatment.name} tooltip={treatment.tooltip} />
              ) : (
                treatment.name
              )}
            </TableCell>
            {treatment.member && (
              <TableCell className="text-juv-terracotta font-semibold">
                {treatment.member}
              </TableCell>
            )}
            {treatment.visitor && (
              <TableCell className="text-juv-deep-chestnut/70">
                {treatment.visitor}
              </TableCell>
            )}
            {treatment.single && (
              <TableCell className="text-juv-terracotta font-semibold">
                {treatment.single}
              </TableCell>
            )}
            {treatment.package && (
              <TableCell className="text-juv-deep-chestnut/70">
                {treatment.package}
              </TableCell>
            )}
            {treatment.price && (
              <TableCell className="text-juv-terracotta font-semibold">
                {treatment.price}
              </TableCell>
            )}
            {treatment.benefits && (
              <TableCell className="text-juv-deep-chestnut/70 text-sm">
                {treatment.benefits}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TreatmentTable;
